
import { defineComponent, PropType } from '@vue/runtime-core';

export default defineComponent({
  name: 'MaterialSelect',
  props: {
    material: {
      type: String as PropType<TArmorType>,
    },
    type: {
      type: String as PropType<TArmorType>,
    },
    options: {
      type: Object as PropType<TAllMaterials>,
    },
    onSetMaterial: {
      type: Function,
      required: true,
    },
  },
});
